import React from 'react';

const ProjectItem = ({ children }) => {
	const className = children?.length ? 'length-' + children.length : '';
	return <li className={className}>{children}</li>;
};

export default ProjectItem;
